import http from '@core/fetch'

const post = url => params => http.post(url, { body: params })

export default {
  // 获取酒店特色详情
  getUniqueInfo: () =>
    http('/p/wedding/Admin/APIMerchantPrivilege/current_list', {
      body: { id: 33 }
    }),
  // 编辑酒店特色详情
  editUniqueInfo: post(
    '/p/wedding/Admin/APIMerchantPrivilege/editHotelFeatures'
  ),
  prohibitCheck: params =>
    http.post('/hms/nuwa/appApi/admin/common/prohibit/check', {
      body: params
    })
}
